import { UnifiedAgentContent } from 'pages/chatbot/ui/UnifiedAgent'

export const ChatbotEditV2Page = () => <UnifiedAgentContent />
